import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mt-4 registro_conten_p_t"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_registroUser = _resolveComponent("registroUser")!

  return (_ctx.vistaComponente)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_registroUser)
      ]))
    : _createCommentVNode("", true)
}